var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { gqlSdk, restClient } from '@cta-portal/webapp-common/lib/api/client';
import { useI18n } from '@cta-portal/webapp-common/lib/hooks/translations/use-i18n';
import { useContext, useEffect } from 'react';
import { DialogContext } from '../../context/dialog';
import { LoadingContext } from '../../context/loading';
import { UserContext } from '../../context/user';
import { DialogType } from '../../types/dialogs';
import { checkUsername } from '../../utils/credentials-check';
import { useInput } from '../common/use-input';
import { useAccountBillingInformation } from './use-account-billing-information';
export function useAccountInformation() {
    var t = useI18n().t;
    var setServerLoading = useContext(LoadingContext).setServerLoading;
    var setDialogProps = useContext(DialogContext).setDialogProps;
    var _a = useContext(UserContext), user = _a.user, reconnectUser = _a.reconnectUser;
    var showUpdateBillingInformationDialog = useAccountBillingInformation().showUpdateBillingInformationDialog;
    var username = useInput('');
    useEffect(function () {
        function getErrors() {
            return __awaiter(this, void 0, void 0, function () {
                var error;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, checkUsername(username.value, t)];
                        case 1:
                            error = _a.sent();
                            username.setError(error);
                            setDialogProps(function (value) {
                                return (value === null || value === void 0 ? void 0 : value.custom.type) === DialogType.UPDATE_USERNAME
                                    ? {
                                        common: __assign(__assign({}, value.common), { actions: [
                                                {
                                                    text: t('common.confirm'),
                                                    action: function () { return updateUsername(username.value); },
                                                    highlighted: true,
                                                    disabled: username.value.length === 0 || Boolean(error),
                                                },
                                            ] }),
                                        custom: __assign(__assign({}, value.custom), { username: __assign(__assign({}, username), { error: error }) }),
                                    }
                                    : value;
                            });
                            return [2 /*return*/];
                    }
                });
            });
        }
        getErrors();
    }, [username.value]);
    useEffect(function () {
        setDialogProps(function (value) {
            return (value === null || value === void 0 ? void 0 : value.custom.type) === DialogType.UPDATE_USERNAME
                ? __assign(__assign({}, value), { custom: __assign(__assign({}, value.custom), { username: username }) }) : value;
        });
    }, [username.error]);
    function hideDialog() {
        username.setValue('');
        username.setError(undefined);
        setDialogProps(undefined);
    }
    function hideDialogAndLogout() {
        restClient.logout();
        hideDialog();
    }
    function showUpdateUsernameDialog() {
        setDialogProps({
            common: {
                title: t('account.my-info.udpate-username.title'),
                close: { text: t('common.back'), action: hideDialog },
                actions: [
                    {
                        text: t('common.confirm'),
                        highlighted: true,
                        disabled: true,
                    },
                ],
            },
            custom: {
                type: DialogType.UPDATE_USERNAME,
                username: username,
                message: t('account.my-info.udpate-username.instruction'),
            },
        });
    }
    function updateUsername(value) {
        return __awaiter(this, void 0, void 0, function () {
            var error, availableUsernameResponse, usernameError, result, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (value.length === 0)
                            return [2 /*return*/];
                        setServerLoading(true);
                        return [4 /*yield*/, gqlSdk.UserIsUsernameAvailable({ input: { username: value } })];
                    case 1:
                        availableUsernameResponse = _a.sent();
                        usernameError = !availableUsernameResponse.userIsUsernameAvailable.available
                            ? t('error.username-already-taken')
                            : undefined;
                        if (!!usernameError) return [3 /*break*/, 5];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, gqlSdk.UserUpdateOne({
                                input: {
                                    username: value,
                                },
                            })];
                    case 3:
                        result = _a.sent();
                        error = !result.userUpdateOne ? t('error.generic') : '';
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        if (err_1 instanceof Error) {
                            if (err_1 instanceof Error) {
                                console.log(err_1.message);
                            }
                            error = t('error.generic');
                        }
                        return [3 /*break*/, 5];
                    case 5:
                        username.setError(usernameError);
                        if (!(!error || !usernameError)) return [3 /*break*/, 7];
                        return [4 /*yield*/, reconnectUser()];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        setServerLoading(false);
                        setDialogProps(function (value) {
                            return usernameError
                                ? value
                                : {
                                    common: {
                                        title: error ? t('common.error') : t('common.success'),
                                        close: { text: t('common.back'), action: hideDialog },
                                    },
                                    custom: {
                                        type: DialogType.SIMPLE,
                                        message: error || t('account.my-info.udpate-username.success-message'),
                                    },
                                };
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    function showUpdatePasswordDialog() {
        setDialogProps({
            common: {
                title: t('account.my-info.udpate-password.title'),
                close: { text: t('common.back'), action: hideDialog },
                actions: [
                    {
                        text: t('common.confirm'),
                        action: updatePassword,
                        highlighted: true,
                    },
                ],
            },
            custom: {
                type: DialogType.SIMPLE,
                message: t('account.my-info.udpate-password.instruction'),
            },
        });
    }
    function updatePassword() {
        return __awaiter(this, void 0, void 0, function () {
            var error, result, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(user === null || user === void 0 ? void 0 : user.email))
                            return [2 /*return*/];
                        setServerLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, restClient.logout()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, gqlSdk.UserResetPasswordInitiate({
                                input: {
                                    email: user.email.toLowerCase(),
                                },
                            })];
                    case 3:
                        result = _a.sent();
                        error = !result.userResetPasswordInitiate ? t('error.generic') : '';
                        return [3 /*break*/, 5];
                    case 4:
                        err_2 = _a.sent();
                        if (err_2 instanceof Error) {
                            if (err_2 instanceof Error) {
                                console.log(err_2.message);
                            }
                            error = t('error.generic');
                        }
                        return [3 /*break*/, 5];
                    case 5:
                        setServerLoading(false);
                        setDialogProps({
                            common: {
                                title: error ? t('common.error') : t('common.success'),
                                close: { text: t('common.back'), action: hideDialogAndLogout },
                            },
                            custom: {
                                type: DialogType.SIMPLE,
                                message: error || t('account.my-info.udpate-password.success-message', { email: user.email }),
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    }
    return {
        showUpdateUsernameDialog: showUpdateUsernameDialog,
        showUpdatePasswordDialog: showUpdatePasswordDialog,
        showUpdateBillingInformationDialog: showUpdateBillingInformationDialog,
    };
}
